import { useState } from "react";
import { Copy, Download, ListPlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { copyEmails, downloadCsv } from "@/lib/exports";
import { formatNumber } from "@/lib/format";
import { AddToListDialog } from "./AddToListDialog";

export function SelectionBar({ selectedIds, onClear }) {
  const [open, setOpen] = useState(false);
  const ids = [...selectedIds];
  if (!ids.length) return null;
  return (
    <>
      <div data-testid="selection-action-bar"
        className="fixed bottom-5 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 flex-wrap items-center gap-2 rounded-2xl border border-stone-700 bg-stone-900 px-4 py-3 text-white shadow-2xl animate-in fade-in slide-in-from-bottom-4 sm:flex-nowrap sm:px-5">
        <span className="mr-auto text-sm font-semibold" data-testid="selection-count">
          {formatNumber(ids.length)} sélectionné{ids.length > 1 ? "s" : ""}
        </span>
        <Button size="sm" className="rounded-full bg-[#EC7F13] font-semibold text-white hover:bg-[#d86f0a]" onClick={() => setOpen(true)} data-testid="action-bar-add-to-list-button">
          <ListPlus className="h-4 w-4" /> Ajouter à une liste
        </Button>
        <Button size="sm" variant="ghost" className="rounded-full text-white hover:bg-white/10 hover:text-white" data-testid="action-bar-copy-emails-button"
          onClick={() => copyEmails(() => api.post("/export/emails", { person_ids: ids }))}>
          <Copy className="h-4 w-4" /> Copier les emails
        </Button>
        <Button size="sm" variant="ghost" className="rounded-full text-white hover:bg-white/10 hover:text-white" data-testid="action-bar-export-csv-button"
          onClick={() => downloadCsv(() => api.post("/export/csv", { person_ids: ids }, { responseType: "blob" }))}>
          <Download className="h-4 w-4" /> CSV
        </Button>
        <button onClick={onClear} className="rounded-full p-1.5 text-stone-400 hover:bg-white/10 hover:text-white" aria-label="Tout désélectionner" data-testid="action-bar-clear-button">
          <X className="h-4 w-4" />
        </button>
      </div>
      <AddToListDialog open={open} onOpenChange={setOpen} personIds={ids} onDone={onClear} />
    </>
  );
}
